// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;



const settings = {
    classes: ''
};




function modal(options) {

var title = options.title,
    content = options.content;


var template = `
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="exampleModalLabel">${title}</h4>
      </div>
      <div class="modal-body">
         ${content}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>`;

    var element = $(template);

    $(document.body).append(element);
    element.modal();

    // if you don't want the modal lingering in the dom after closing, optionally remove it.
    if (options.destroy) {
        element.on('hidden.bs.modal', function() {
            $(element).remove();
        });
    }

}



export default class {

    // Starts here.
    constructor() {
        this.setInitialState();
        this.setCache();
        this.bindEvents();
    }


    // set a state object (for checking different states the mini-cart might have)
    setInitialState() {
        this.state = {
            // isOpen: false,
        };
    }

    // cache DOM elements when possible for performance
    setCache () {
        this.cache = {};
        this.cache.body = $(document.body); // lots of woocommerce events get fired here.
    }


    // bind the different events that interact with the component
    bindEvents () {

        this.cache.body.on('error', this.handleError.bind(this));
        this.cache.body.on('modal', this.handleModal.bind(this));
        this.cache.body.on('click', '[data-trigger="modal"]', this.openDataModal.bind(this));

        // here we hack the window.alert function to use or modals instead. This is helpfrul for example with Woocommerce
        window.alert = this.handleAlerts;
    }

    // this should be smarter, handle custom error messages, etc.
    handleError(event, options) {
        console.log("handleError");
        modal({
            title: "Error",
            content: "There was an erorr in the request."
        });
    }

    // basically just hands off to the modal function, but some smarts can go into this.
    handleModal(event, options) {
        modal(options);
    }

    // overwrite the window.alert function.
    handleAlerts(message) {

        modal({
            title: "Oops!",
            content: message,
            destroy: true // make sure it doesn't linger in the DOM after closing.
        });
    }

    // open a modal via data attributes.
    // TODO: Make this smarter.
    openDataModal(e) {

        var target = $(e.target);
        var data = target.data();
        var content;

        if (data.content) {
            content = $(data.content);
        }


        modal({
            title: data.title,
            content: content[0].innerHTML,
            destroy: true // make sure it doesn't linger in the DOM after closing.
        });

    }






}